import { Navigate, Route, Routes } from 'react-router-dom';
import { Shell } from './components/Shell';
import { WorkspaceProvider } from './context/WorkspaceContext';
import { CyclesPage } from './pages/CyclesPage';
import { EvidencePage } from './pages/EvidencePage';
import { ExceptionsPage } from './pages/ExceptionsPage';
import { InventoryPage } from './pages/InventoryPage';
import { LineagePage } from './pages/LineagePage';
import { MappingPage, ValidationPage } from './pages/MappingValidationPages';
import { OverviewPage } from './pages/OverviewPage';
import { RadarPage } from './pages/RadarPage';
import { ReportsPage } from './pages/ReportsPage';
import { SettingsPage } from './pages/SettingsPage';

function NotFoundPage() {
  return (
    <div className="not-found">
      <span>404</span>
      <h1>Seite nicht gefunden</h1>
      <p>Die angeforderte Ansicht ist in diesem Workspace nicht verfügbar.</p>
      <a className="button button-primary" href="/overview">Zur Executive Overview</a>
    </div>
  );
}

export default function App() {
  return (
    <WorkspaceProvider>
      <Shell>
        <Routes>
          <Route path="/" element={<Navigate to="/overview" replace />} />
          <Route path="/overview" element={<OverviewPage />} />
          <Route path="/radar" element={<RadarPage />} />
          <Route path="/inventory" element={<InventoryPage />} />
          <Route path="/lineage" element={<LineagePage />} />
          <Route path="/mapping" element={<MappingPage />} />
          <Route path="/validation" element={<ValidationPage />} />
          <Route path="/cycles" element={<CyclesPage />} />
          <Route path="/exceptions" element={<ExceptionsPage />} />
          <Route path="/evidence" element={<EvidencePage />} />
          <Route path="/reports" element={<ReportsPage />} />
          <Route path="/settings" element={<SettingsPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </Shell>
    </WorkspaceProvider>
  );
}
